<app-primary-navigation></app-primary-navigation>
<mat-sidenav-container class="api-container">
  <elements-stoplight-project
    projectId="{{ projectId }}"
    router="history"
    basePath="{{ basePath }}"
    collapseTableOfContents="true"
  ></elements-stoplight-project>
</mat-sidenav-container>
